import { useState } from "react";
import { motion } from "framer-motion";
import { createItem } from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { analytics } from "@/lib/analytics";

export function Newsletter() {
  const [email, setEmail]     = useState("");
  const [name, setName]       = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone]       = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await createItem("subscribe", { email, name });
      setDone(true);
      analytics.newsletterSignup(email);
      toast.success("🎉 Welcome to NC Desi!", { description: "You're now part of something real." });
    } catch {
      toast.error("Couldn't subscribe. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="newsletter" className="bg-white border-t border-[#d2d2d7] py-20 sm:py-28">
      <div className="max-w-[600px] mx-auto px-4 sm:px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {/* Eyebrow */}
          <p className="text-[13px] font-semibold tracking-[0.08em] uppercase text-[#6e6e73] mb-4">
            Join NC Desi
          </p>

          {/* Heading */}
          <h2
            className="text-[48px] sm:text-[56px] font-bold text-[#1d1d1f] mb-5"
            style={{ letterSpacing: "-0.04em", lineHeight: "1.04" }}
          >
            You belong here.
          </h2>

          {/* Subtext */}
          <p className="text-[17px] text-[#6e6e73] leading-[1.52] mb-10">
            Get weekly events, jobs, housing leads, and community news — straight to your inbox. No spam. Unsubscribe anytime.
          </p>

          {done ? (
            <p className="text-[#0071e3] text-[19px] font-semibold">
              🎉 You're in! Watch your inbox.
            </p>
          ) : (
            <form onSubmit={submit} className="flex flex-col gap-3">
              <input
                type="text"
                placeholder="Your name (optional)"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full h-[44px] px-4 rounded-xl border border-[#d2d2d7] text-[15px] text-[#1d1d1f] placeholder-[#6e6e73] focus:outline-none focus:border-[#0071e3] focus:ring-2 focus:ring-[#0071e3]/20 transition-all bg-white"
              />
              <input
                type="email"
                required
                placeholder="Your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full h-[44px] px-4 rounded-xl border border-[#d2d2d7] text-[15px] text-[#1d1d1f] placeholder-[#6e6e73] focus:outline-none focus:border-[#0071e3] focus:ring-2 focus:ring-[#0071e3]/20 transition-all bg-white"
              />
              <button
                type="submit"
                disabled={loading}
                className="w-full h-[44px] bg-[#0071e3] hover:bg-[#0077ed] active:bg-[#006edb] disabled:opacity-60 text-white text-[15px] font-medium rounded-[980px] transition-colors duration-150 flex items-center justify-center gap-2"
              >
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Join Free"}
              </button>
              <p className="text-[13px] text-[#6e6e73] mt-1">Free. No credit card needed. Unsubscribe anytime.</p>
            </form>
          )}
        </motion.div>
      </div>
    </section>
  );
}
